import { useMemo } from 'react'

import { isDefined } from 'aem-libs-ts/src/utils/common/isDefined'

const MONTHS_IN_YEAR = 12

export type MonthsSplitResult = {
  months: number
  years: number
}

export const useMonthsSplit = (monthsCount: number): MonthsSplitResult => {
  return useMemo(() => {
    return {
      months: isDefined(monthsCount) ? monthsCount % MONTHS_IN_YEAR : 0,
      years: isDefined(monthsCount) ? Math.floor(monthsCount / MONTHS_IN_YEAR) : 0
    }
  }, [monthsCount])
}
